// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-list {
  background: #FFFDFC;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 2rem;
}

.documents-list h2 {
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(215, 217, 217, 0.25);;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
}

.document-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.document-info svg {
  width: 20px;
  height: 20px;
  color: #6B7280;
}

.download-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: none;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  cursor: pointer;
  color: #6B7280;
  transition: all 0.2s ease;
}

.download-button:hover {
  background: #F3F4F6;
}

.download-button svg {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/composants/DocumentsList/DocumentsList.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".documents-list {\r\n  background: #FFFDFC;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n}\r\n\r\n.documents-list h2 {\r\n  font-size: 2.4rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.documents-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 1rem;\r\n}\r\n\r\n.document-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem;\r\n  background: rgba(215, 217, 217, 0.25);;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 6px;\r\n}\r\n\r\n.document-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.document-info svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #6B7280;\r\n}\r\n\r\n.download-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  background: none;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  color: #6B7280;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.download-button:hover {\r\n  background: #F3F4F6;\r\n}\r\n\r\n.download-button svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
